<template>
  <div>
    <loading v-if="loading"/>
    <div v-else>
      <h2 class="text-primary-dark seccion">
        Póliza
        <router-link :to="{name: 'nuevoSiniestro', params: { poliza: this.$route.params.id }}" class="d-none d-md-inline-block btn btn-primary float-right"><font-awesome-icon icon="plus"/> Dar parte</router-link>
        <router-link :to="{name: 'nuevoSiniestro', params: { poliza: this.$route.params.id }}" class="d-inline-block d-md-none btn btn-sm btn-primary float-right mt-0">Dar parte</router-link>
      </h2>

      <div class="text-center">
        <logo-cia :id="poliza.compania.id" class="logo-cia-gr"/>
      </div>
      <div class="row">
        <div class="col-md-8">
          <label class="label-ficha">Tomador</label>
          {{ poliza.cliente.tomador }}
        </div>
        <div class="col-md-4">
          <label class="label-ficha">Póliza</label>
          {{ poliza.numPoliza }}
        </div>
      </div>
      <div class="row">
        <div class="col-md-3">
          <label class="label-ficha">Efecto</label>
          {{ poliza.fechaEfecto|fecha }}
        </div>
        <div class="col-md-3">
          <label class="label-ficha">Vencimiento</label>
          {{ poliza.fechaVencimiento|fecha }}
        </div>
        <div class="col-md-2">
          <label class="label-ficha">Estado</label>
          {{ poliza.estado.descripcion }}
        </div>
        <div class="col-md-4">
          <label class="label-ficha">Forma de pago</label>
          {{ poliza.formaPago.descripcion }}
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <label class="label-ficha">Ramo</label>
          {{ poliza.producto.ramo.nombre }}
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <label class="label-ficha">Riesgos</label>
          <span v-for="riesgo in poliza.riesgos" :key="riesgo.id">
            <span v-if="poliza.producto.ramo.naturaleza == 1">
              {{ riesgo.riesgo.nombreCorto }} - {{ riesgo.riesgo.descripcion }}
            </span>
            <span v-else>
              {{ riesgo.riesgo.descripcion }}
            </span>
            <div class="row">
              <div class="col-md-6" v-if="riesgo.riesgo.garantias && riesgo.riesgo.garantias.length > 0">
                <div v-for="garantia in riesgo.riesgo.garantias" :key="garantia.id">
                 {{ garantia.garantia.descripcion }}: {{ garantia.franquicia }}
                </div>
              </div>
            </div>
          </span>
        </div>
      </div>
      
      <ul class="nav nav-tabs mt-3 mb-4">
        <li class="nav-item w-25 text-center text-md-left">
          <a class="nav-link text-dark" 
            :class="{ 'border-gris-claro': (tabActive != 'incidenciasCliente'), 'border-primary': (tabActive == 'incidenciasCliente'),'active': (tabActive == 'incidenciasCliente') }" 
            @click="selectTab('incidenciasCliente')" href="javascript:void(0)">
            <span class="d-none d-md-inline"><font-awesome-icon icon="comments"/> Notas</span>
            <font-awesome-icon icon="comments" class="py-1 fa-2x text-gris-claro d-inline d-md-none"/>
          </a>
        </li>
        <li class="nav-item w-25 text-center text-md-left">
          <a class="nav-link text-dark" 
            :class="{ 'border-gris-claro': (tabActive != 'documentos'), 'border-primary': (tabActive == 'documentos'),'active': (tabActive == 'documentos') }" 
            @click="selectTab('documentos')" href="javascript:void(0)">
            <span class="d-none d-md-inline"><font-awesome-icon icon="paperclip"/> Documentos</span>
            <font-awesome-icon icon="paperclip" class="py-1 fa-2x text-gris-claro d-inline d-md-none"/>
            </a>
        </li>
        <li class="nav-item w-25 text-center text-md-left">
          <a class="nav-link text-dark" 
            :class="{ 'border-gris-claro': (tabActive != 'recibos'), 'border-primary': (tabActive == 'recibos'),'active': (tabActive == 'recibos') }" 
            @click="selectTab('recibos')" href="javascript:void(0)">
            <span class="d-none d-md-inline"><font-awesome-icon icon="euro-sign"/> Recibos</span>
            <font-awesome-icon icon="euro-sign" class="py-1 fa-2x text-gris-claro d-inline d-md-none"/>
            </a>
        </li>
        <li class="nav-item w-25 text-center text-md-left">
          <a class="nav-link text-dark" 
            :class="{ 'border-gris-claro': (tabActive != 'siniestros'), 'border-primary': (tabActive == 'siniestros'),'active': (tabActive == 'siniestros') }" 
            @click="selectTab('siniestros')" href="javascript:void(0)">
            <span class="d-none d-md-inline"><font-awesome-icon icon="exclamation-triangle"/> Siniestros</span>
            <font-awesome-icon icon="exclamation-triangle" class="py-1 fa-2x text-gris-claro d-inline d-md-none"/>
            </a>
        </li>
      </ul>
      <div class="tab-content px-0">
        <div class="tab-pane" :class="{ 'show': (tabActive == 'incidenciasCliente'), 'active': (tabActive == 'incidenciasCliente') }">
          <incidencias-cliente :idObjeto="poliza.id" tipoObjeto="7"/>
        </div>
        <div class="tab-pane" :class="{ 'show': (tabActive == 'documentos'), 'active': (tabActive == 'documentos') }">
          <documentos-item :idObjeto="poliza.id" tipoObjeto="7"/>
        </div>
        <div class="tab-pane" :class="{ 'show': (tabActive == 'recibos'), 'active': (tabActive == 'recibos') }">
          <recibos-poliza :idPoliza="poliza.id"/>
        </div>
         <div class="tab-pane" :class="{ 'show': (tabActive == 'siniestros'), 'active': (tabActive == 'siniestros') }">
          <siniestros-poliza :idPoliza="poliza.id"/>
        </div>
      </div>

    </div> 
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import util from '@/util'
import Loading from '@/components/widgets/Loading'
import LogoCia from '@/components/widgets/LogoCia'
import DocumentosItem from '@/components/comunes/DocumentosItem'
import IncidenciasCliente from '@/components/comunes/IncidenciasCliente'
import RecibosPoliza from '@/components/polizas/RecibosPoliza'
import SiniestrosPoliza from '@/components/polizas/SiniestrosPoliza'
import LabelEditable from '@/components/widgets/LabelEditable'
export default {
  data() {
    return {
      loading: true,
      poliza: {},
      tabActive: 'incidenciasCliente'
    }
  },
  computed: {
    ...mapGetters({
      urlBase: 'urlBase'
    })
  },
  mounted() {
    if (this.poliza && this.poliza.id == this.$route.params.id) {
      this.loading = false;
    } else {
      this.poliza = {};
    }
    this.getPoliza(this.$route.params.id);
  },
  methods: {
    editado() {
      console.log("Guardar")
    },
    getPoliza(id) {
      let grupos = [
        'poliza.producto',
        'poliza.riesgos',
        'poliza.compania',
        'poliza.cliente',
        'producto.ramo',
        'compania.telefonos',
        'riesgoPoliza.riesgo',
        'telefonoscompania.ramos'
      ]
      let params = {
        'grupos': grupos.join(',')
      }

      let url = this.urlBase + 'polizas/' + id + '?' + util.objToQuery(params);
      this.$http.get(url).then(
          (response) => {
            this.poliza = response.body;
            this.loading = false;
          },
          (error) => {
            this.loading = false;
            if (error.status === 401) {
              this.$router.push({name:'Login'});
            }
          }
      );
    },
    selectTab(tab) {
      this.tabActive = tab;
    }
  },
  components: {
    Loading,
    LogoCia,
    DocumentosItem,
    RecibosPoliza,
    IncidenciasCliente,
    SiniestrosPoliza,
    LabelEditable
  }
}
</script>
